<div class="example-container">
  <div class="main-container">
    <div class="title">
      <h2>OCR Client Actions</h2>
    </div>
    <div class="action-row">
      <module-container>
        <div class="form-container">
          <span class="label">Release files</span>

          <mat-form-field color="primary" class="input-field" appearance="outline">
            <mat-label>Client</mat-label>
            <mat-select [(value)]="selectedClient">
              <mat-option
                ngClass="selectFormOption"
                *ngFor="let client of clients"
                [value]="client.value"
              >
                {{ client.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            pButton
            type="button"
            class="ui-button-danger ui-button-danger"
            type="button"
            (click)="releaseFiles()"
            label="Release Files"
          ></button>
        </div>
      </module-container>
    </div>

    <div class="title">OCR Importer Actions</div>
    <div class="action-row">
      <!-- IMPORT TO CLICK -->
      <module-container>
        <div class="form-container">
          <span class="label">Re-Import to Click</span>

          <mat-form-field color="primary" class="input-field" appearance="outline">
            <mat-label>UUID</mat-label>
            <input (change)="importUuid = $event.target.value" matInput placeholder="uuid" />
          </mat-form-field>
          <button
            pButton
            type="button"
            class="ui-button-danger ui-button-danger"
            type="button"
            (click)="onSubmit(importUuid, 'import-to-click')"
            label="ReImport to Click"
          ></button>
        </div>
      </module-container>
      <!-- RELEASE -->
      <module-container>
        <div class="form-container">
          <span class="label">Release Documents</span>

          <mat-form-field color="primary" class="input-field" appearance="outline">
            <mat-label>UUID</mat-label>
            <input (change)="releaseUuid = $event.target.value" matInput placeholder="uuid" />
          </mat-form-field>
          <button
            pButton
            type="button"
            class="ui-button-danger ui-button-danger"
            type="button"
            (click)="onSubmit(releaseUuid, 'release')"
            label="Release Document"
          ></button>
        </div>
      </module-container>
      <!-- IMPORT TO CLICK -->
      <module-container>
        <div class="form-container">
          <span class="label">Redo Category Job</span>

          <mat-form-field color="primary" class="input-field" appearance="outline">
            <mat-label>UUID</mat-label>
            <input (change)="redoCategoryUuid = $event.target.value" matInput placeholder="uuid" />
          </mat-form-field>
          <button
            pButton
            type="button"
            class="ui-button-danger ui-button-danger"
            type="button"
            (click)="onSubmit(redoCategoryUuid, 'redo-category-in-web')"
            label="Redo Category Job"
          ></button>
        </div>
      </module-container>
    </div>
  </div>
</div>
